var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Location } from '@angular/common';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { PostOverviewComponent } from '../../post-overview/post-overview.component';
import { InfluencerPostService } from '../../../services/influencer-post/influencer-post.service';
import { CommonService } from '../../../services/common/common.service';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { DiscoverService } from '../../../services/discover/discover.service';
import { ModalService } from '../../../services/modal/modal.service';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { PdfViewerService } from '../pdf-viewer.service';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { EventTrackerService } from '../../../services/event-tracker/event-tracker.service';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from '../../../services/cache/cache.service';
export var ServiceCounter;
(function (ServiceCounter) {
    ServiceCounter[ServiceCounter["init"] = 0] = "init";
    ServiceCounter[ServiceCounter["max"] = 6] = "max";
    ServiceCounter[ServiceCounter["renderTimeout"] = 500] = "renderTimeout";
})(ServiceCounter || (ServiceCounter = {}));
var PostOverviewPdfViewerComponent = /** @class */ (function (_super) {
    __extends(PostOverviewPdfViewerComponent, _super);
    function PostOverviewPdfViewerComponent(route, router, location, influencerPostService, commonService, influencerService, userService, campaignService, referenceDataService, discoverService, modalService, placeholderService, pdfViewerService, pdfService, translate, cacheService, eventTracker, pdfExportService) {
        var _this = _super.call(this, route, router, location, influencerPostService, commonService, influencerService, userService, campaignService, referenceDataService, discoverService, modalService, placeholderService, pdfViewerService, pdfService, translate, cacheService, eventTracker) || this;
        _this.pdfExportService = pdfExportService;
        return _this;
    }
    PostOverviewPdfViewerComponent.prototype.ngOnInit = function () {
        var _this = this;
        // disable highchart animation
        var highcharts = require('highcharts');
        highcharts.setOptions({
            chart: {
                animation: false
            },
            plotOptions: {
                series: {
                    animation: false
                }
            }
        });
        _super.prototype.ngOnInit.call(this);
        this.pdfExportService.triggerIncrementReportReady.subscribe(function (numberReportReady) {
            if (numberReportReady === ServiceCounter.max) {
                console.log(' ***************************************** POST READY TO EXPORT PDF *****************************************');
                setTimeout(function () {
                    _this.pdfReady();
                }, ServiceCounter.renderTimeout);
            }
        });
    };
    PostOverviewPdfViewerComponent.prototype.pdfReady = function () {
        if (window && typeof window.pdfReady === 'function') {
            setTimeout(function () {
                window.pdfReady();
            }, ServiceCounter.renderTimeout);
        }
    };
    Object.defineProperty(PostOverviewPdfViewerComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.logoImage;
        },
        enumerable: true,
        configurable: true
    });
    return PostOverviewPdfViewerComponent;
}(PostOverviewComponent));
export { PostOverviewPdfViewerComponent };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/post-overview-pdf-viewer/post-overview-pdf-viewer.component.ts.pre-build-optimizer.js